import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { RouteContext } from '../RouteContext';
/**
 * Enhances the routes array by adding the parent route and the absolute path.
 */
const enhanceRoutes = (routes, parent = undefined, prefixPath = '') => {
    return routes.map((route) => {
        const absolutePath = `${prefixPath}${route.path}`;
        const processedRoute = Object.assign(Object.assign({}, route), { routes: [], parent, absolutePath });
        processedRoute.routes = enhanceRoutes(route.routes, processedRoute, absolutePath);
        return processedRoute;
    });
};
/**
 * Provides a context that holds the information of the current routes.
 */
export const RouteContextProvider = ({ routes, children }) => {
    const context = useMemo(() => {
        return { routes: enhanceRoutes(routes) };
    }, [routes]);
    return _jsx(RouteContext.Provider, Object.assign({ value: context }, { children: children }), void 0);
};
//# sourceMappingURL=RouteContextProvider.js.map